import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Styled from 'src/components/JobMobileDataTab/JobMobilData.styles';
import MobilePhotoAttachmentViewer from 'src/components/MobilePhotoAttachmentViewer';
import { getPreSignedUrl } from 'src/utils/helpers';
import { useGetMobilePhotoRecordData } from 'src/hooks/job';
import ButtonTag from 'src/components/ButtonTag';
import _, { uniqWith } from 'lodash';

const CapFindingMobileData = ({ currentFinding }) => {

  const [selectedImageToPreview, setSelectedImageToPreview] = useState(0);
  const [photoViewerVisible, setPhotoViewerVisible] = useState(false);
  const { jobId } = currentFinding;
  const { photoRecordsData = [], execute: getPhotoRecordsFromDB } = useGetMobilePhotoRecordData(jobId);
  const [chunkedRecords, setChunkedRecords] = useState([]);
  const [findingPhotoRecords, setFindingPhotoRecords] = useState([]);

  useEffect(() => {
    if (jobId) {
      getPhotoRecordsFromDB();
    }
  }, [jobId]);

  useEffect(() => {
    setFindingPhotoRecords(uniqWith([...photoRecordsData].filter(
      v => v.questionId === currentFinding.checklistQuestionId,
    ), (a, b) => {
      return a.questionId === b.questionId &&
          a.filename === b.filename;
    }),);
  }, [photoRecordsData]);

  useEffect(() => {
    const chunkifiedRecordsArray = _.chunk(findingPhotoRecords, 3);
    const chunkifiedRecordsWorkingCopy = [...chunkifiedRecordsArray];
    for (let i = 0; i < findingPhotoRecords.length; i += 1) {
      for (let a = 0; a < 3; a += 1) {
        if (chunkifiedRecordsWorkingCopy[i]) {
          const jobattachmentId = chunkifiedRecordsWorkingCopy[i][a] ? chunkifiedRecordsWorkingCopy[i][a].attachmentId : null;
          const primaryRecord = photoRecordsData.find(c => c.isPrimary && c.attachmentId === jobattachmentId);
          const attachmentIdToLoad = primaryRecord?.showAltered ? primaryRecord.alteredAttachmentId : (primaryRecord?.attachmentId || jobattachmentId);
          const promise = getPreSignedUrl(attachmentIdToLoad, null, 'sm');
          promise.then((res) => {
            chunkifiedRecordsWorkingCopy[i][a].src = res;
            setChunkedRecords([...chunkifiedRecordsWorkingCopy]);
          });
        }
      }
    }
  }, [findingPhotoRecords]);

  const getImageCaption = (recordId) => {
    return ((photoRecordsData || []).find(photoRecord => photoRecord.id === recordId)?.tags || [])
      .filter(tag => !!tag.name)
      .map(tag => <ButtonTag key={tag.id} showCrossIcon={false} text={tag.name} />);
  };

  const onImageClicked = (clickedImageId) => {
    setSelectedImageToPreview(
      findingPhotoRecords.findIndex(record => record.id === clickedImageId),
    );
    setPhotoViewerVisible(true);
  };

  const renderPhotoViewer = () => {
    return <MobilePhotoAttachmentViewer
      allPhotoRecords={photoRecordsData}
      clickedImageIndex={selectedImageToPreview}
      closeHandler={() => setPhotoViewerVisible(false)}
      getPhotoRecordsFromDB={getPhotoRecordsFromDB}
      isEditableByUser={false}
      isJobUnderReview={false}
      jobId={jobId}
      photoRecords={findingPhotoRecords.map(c => photoRecordsData.find(cc => cc.isPrimary && cc.attachmentId === c.attachmentId))}
      showLinks={false}
    />;
  };

  return (
    <>
        <Styled.Container>
            {chunkedRecords.map((chunkRecord, index) => (
                  <Styled.Grid key={index}>
                    {
                      chunkRecord.map((item) => (
                        <Styled.ImageHolder
                          key={item.id}>
                          <Styled.Figure border_light>
                              <Styled.ImageDiv
                                backgroundImage={item.src}
                                className="findings-mobile-data-image"
                                onClick={() => onImageClicked(item.id)}
                                small />
                          </Styled.Figure>
                        </Styled.ImageHolder>
                      ))}
                  </Styled.Grid>
              ))}
        </Styled.Container>
        {photoViewerVisible ? renderPhotoViewer() : null}
    </>
  );
};

CapFindingMobileData.propTypes = {
  currentFinding: PropTypes.object
};

CapFindingMobileData.defaultProps = {
};

export default React.memo(CapFindingMobileData);
